import { render, staticRenderFns } from "./MyClients.vue?vue&type=template&id=436d5eec&scoped=true"
import script from "./MyClients.vue?vue&type=script&lang=js"
export * from "./MyClients.vue?vue&type=script&lang=js"
import style0 from "./MyClients.vue?vue&type=style&index=0&id=436d5eec&prod&lang=scss&scoped=true"
import style1 from "./MyClients.vue?vue&type=style&index=1&id=436d5eec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436d5eec",
  null
  
)

export default component.exports